import React from "react";

import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Avatar } from "antd";

import { StepStatus } from "./utils";

import "./StepCircle.css";

export default function StepCircle(props) {
  const {
    number, status, title, isOptional = false,
  } = props;

  let marker;
  if (status === StepStatus.ERROR) {
    marker = (
      <Avatar
        size={40}
        className="StepCircle__avatar StepCircle__avatar--error"
        icon={<ExclamationCircleOutlined />}
        aria-label="Step error"
      />
    );
  } else if (status === StepStatus.FINISHED) {
    marker = (
      <Avatar
        size={40}
        className="StepCircle__avatar StepCircle__avatar--done"
        icon={<CheckOutlined />}
        aria-label="Step complete"
      />
    );
  } else {
    const muted = status === StepStatus.WAITING;
    marker = (
      <Avatar
        size={40}
        className={`StepCircle__avatar StepCircle__avatar--ring${muted ? " StepCircle__avatar--muted" : ""}`}
        aria-label={`Step ${number}`}
      >
        {number}
      </Avatar>
    );
  }

  return (
    <div className="StepCircle">
      {marker}
      <div className="StepCircle__labels">
        <div className="StepCircle__title">{title}</div>
        {isOptional && <div className="StepCircle__optional">Optional</div>}
      </div>
    </div>
  );
}
